<template>
    <div>
      <div class="top_image_container">
        <div class="background_image_container w-full">
          <img src="img/profile-background.jpg" class="background_img w-full" />
        </div>
  
        <!--==== CONTAINER DE IMAGENS E COMPONENTE DE PESQUISA ====-->
        <div class="flex flex-col items-center mt-negative20">
          <img src="img/funcionarioperfil.png" class="w40 border4 border-white rounded-full" />
          <pesquisarFuncionario @estudanteEscolhido="PesquisaLocal" />
        </div>
        <!--==== FIM DO CONTAINER DE PESQUISA ====-->
      </div>
  
      <div style="margin-top: 15px; background-color: #fff;">
        <ListarRegistros v-if="funcionario" :funcionario="funcionario" />
      </div>
    </div>
  </template>
  
  <script>
  import pesquisarFuncionario from "../../components/funcionario/pesquisar.vue";
  import ListarRegistros from "../../components/funcionario/ListarRegistros.vue";
  
  export default {
    components: {
      pesquisarFuncionario,
      ListarRegistros,
    },
    data: () => ({
      funcionario: null,
    }),
  
    methods: {
      PesquisaLocal(funcionario) {
        this.funcionario = null; // Reseta o funcionário antes de definir um novo
        this.$nextTick(() => {
          this.funcionario = funcionario; // Atualiza após o reset
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .top_image_container {
    background-color: #fff;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding-bottom: 1rem;
  }
  .background_image_container {
    height: 150px;
  }
  .background_image_container .background_img {
    height: 100%;
  }
  .w-full {
    width: 100%;
  }
  .background_image_container .background_img {
    height: 100%;
  }
  .flex {
    display: flex;
  }
  .flex-col {
    flex-direction: column;
  }
  .items-center {
    align-items: center;
  }
  .mt-negative20 {
    margin-top: -100px;
  }
  
  .w40 {
    width: 10rem;
  }
  
  .border4 {
    border-width: 0.25rem;
  }
  
  .border-white {
    border-color: #fff;
  }
  .rounded-full {
    border-radius: 50%;
  }
  </style>
  